/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      {title: '학원관리',   url: '/institute/institute-list', icon: 'ListIcon', is_bookmarked: true},
      {title: 'Book', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
/* eslint-enable */
